export const otherText = "Other";
export const otherTextSeparator = " - ";
export const arrayDelimiter = "|";
export const notificationSuffix = `_notification`;
export const helpTextSuffix = "_helpText";

export const inputType = {
    EMAIL: "email",
    CHECKBOX: "checkbox",
	NUMBER: "number",
	PASSWORD: "password",
    RADIO: "radio",
    TEXT: "text",
};

export const inputStyles = {
button: {
    types: {
        CLEAR: " clearIcon ",
        FIRST: " firstIcon ",
        LAST: " lastIcon ",
        NEXT: " nextIcon ",
        PREVIOUS: " previousIcon ",
        SEARCH: " searchIcon ",
    },
        theme: " button ",
        hasSpacing: " btnLayout ",
	    isCollapsed: "",
        isExpanded: " expanded ",
        isLarge: " large ",
        isLink: " button-link ",
        isPrimary: "",
	    isRibbon: " button--ribbon ",
	    isSecondary: " hollow ",
	    isTertiary: " button--tertiary ",
        notCentered: " notCentered "
    },
};

export const DateTimePickerType = {
    Calendar: 0,
    CalendarWithTime: 1,
    TimeOnly: 2
};

export const YesOrNo = {
    YES: "Yes",
    NO: "No",
}